import { createSlice } from '@reduxjs/toolkit';

export const coreSlice = createSlice({
    name: "core",
    initialState: null,
    reducers: {
        set: (state, action) => {
            state = action.payload;
            return state;
        }
    }
})

export const coreActions = coreSlice.actions;

export default coreSlice.reducer;